import { render, staticRenderFns } from "./promocode-edit.vue?vue&type=template&id=83b9e628"
import script from "./promocode-edit.vue?vue&type=script&lang=js"
export * from "./promocode-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports